// extracted by mini-css-extract-plugin
export default {"form":"styles_form__DYO4u","input-error":"styles_input-error__QlWBH","buttons":"styles_buttons__AChJA"};